import extend from '@/utils/vuex-extend';
import Base from './base';

export default extend(Base, {
    state: {
        list: [],
        page: {
            pageSize: 50,
            current: 1,
            total: 0
        }
    },
    actions: {
        async getData({ commit, state, dispatch }, payload) {
            const { page } = state;
            const { caller, hasPage = true, options } = payload;
            let params = options;
            if (hasPage) {
                params = {
                    pageNum: page.current,
                    pageSize: page.pageSize,
                    ...params
                }
            }
            const response = await caller(params);
            if (hasPage) {
                commit('save', {
                    list: response.data.list,
                    page: {
                        total: response.data.total,
                        pageNum: response.data.pageNum,
                        pageSize: response.data.pageSize
                    }
                })
            } else {
                commit('save', {
                    list: response.data
                })
            }
        },
        async changePageSize({ commit, dispatch, state }, payload) {
            const { page } = state;
            commit('save', {
                page: {
                    ...page,
                    pageSize: payload
                }
            });
            dispatch('getList');
        }
    }
})



// WEBPACK FOOTER //
// ./src/vuex-extend/table.js